import { render, staticRenderFns } from "./CostTrend.vue?vue&type=template&id=289d3bb9&scoped=true"
import script from "./CostTrend.vue?vue&type=script&lang=js"
export * from "./CostTrend.vue?vue&type=script&lang=js"
import style0 from "./CostTrend.vue?vue&type=style&index=0&id=289d3bb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289d3bb9",
  null
  
)

export default component.exports